import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const FloatingMenu = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update isMobile state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Common styles for all buttons
  const floatingMenuStyle = {
    position: 'fixed',
    right: isMobile ? '10px' : '20px',
    top: isMobile ? 'auto' : '50%',
    bottom: isMobile ? '20px' : 'auto',
    transform: isMobile ? 'none' : 'translateY(-50%)',
    display: 'flex',
    flexDirection: isMobile ? 'row' : 'column',
    gap: isMobile ? '8px' : '15px',
    zIndex: 100
  };

  // Common styles for all buttons (light soft pink background)
  const buttonBaseStyle = {
    width: isMobile ? '40px' : '50px',
    height: isMobile ? '40px' : '50px',
    borderRadius: '50%',
    backgroundColor: '#FFF0F5', // Light soft pink
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    cursor: 'pointer'
  };

  // Hover effect for buttons
  const getButtonHoverStyles = () => ({
    transform: 'scale(1.1)',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)'
  });

  return (
    <div style={floatingMenuStyle} className="floating-menu">
      {/* Problem - Purple icon (question mark with curly decoration) */}
      <Link 
        to="/problem" 
        title="Problem" 
        className="floating-btn"
        style={buttonBaseStyle}
        onMouseOver={e => Object.assign(e.currentTarget.style, getButtonHoverStyles())}
        onMouseOut={e => Object.assign(e.currentTarget.style, {transform: 'scale(1)', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'})}
      >
        <svg width={isMobile ? "18" : "24"} height={isMobile ? "18" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#663399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 8V12" stroke="#663399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 16H12.01" stroke="#663399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 9.5C9 8.12 10.12 7 11.5 7H12.5C13.88 7 15 8.12 15 9.5V9.65C15 10.96 14.05 11.96 12.75 12H12.5" stroke="#663399" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Link>

      {/* Solution - Green icon (puzzle piece with solution path) */}
      <Link 
        to="/solution" 
        title="Solution" 
        className="floating-btn"
        style={buttonBaseStyle}
        onMouseOver={e => Object.assign(e.currentTarget.style, getButtonHoverStyles())}
        onMouseOut={e => Object.assign(e.currentTarget.style, {transform: 'scale(1)', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'})}
      >
        <svg width={isMobile ? "18" : "24"} height={isMobile ? "18" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.5 14.5L5.5 17.5L8.5 20.5" stroke="#218838" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5.5 17.5H15C17.2091 17.5 19 15.7091 19 13.5V13.5C19 11.2909 17.2091 9.5 15 9.5H12" stroke="#218838" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 8L14.5 5.5L12 3" stroke="#218838" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 4.5C6.5 4.5 4.5 6.5 4.5 9C4.5 11.5 6.5 13.5 9 13.5" stroke="#218838" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Link>

      {/* Features - Red icon (feature list with checkmarks) */}
      <Link 
        to="/features" 
        title="Features" 
        className="floating-btn"
        style={buttonBaseStyle}
        onMouseOver={e => Object.assign(e.currentTarget.style, getButtonHoverStyles())}
        onMouseOut={e => Object.assign(e.currentTarget.style, {transform: 'scale(1)', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'})}
      >
        <svg width={isMobile ? "18" : "24"} height={isMobile ? "18" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7H10C8.89543 7 8 7.89543 8 9V19C8 20.1046 8.89543 21 10 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z" stroke="#D83B3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15 21V5C15 3.89543 14.1046 3 13 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H8" stroke="#D83B3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15 13H17" stroke="#D83B3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15 17H17" stroke="#D83B3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5 7H7" stroke="#D83B3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M5 11H11" stroke="#D83B3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Link>

      {/* Tech Deep Dive - Blue icon (code/tech/data representation) */}
      <Link 
        to="/tech" 
        title="Tech Deep Dive" 
        className="floating-btn"
        style={buttonBaseStyle}
        onMouseOver={e => Object.assign(e.currentTarget.style, getButtonHoverStyles())}
        onMouseOut={e => Object.assign(e.currentTarget.style, {transform: 'scale(1)', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'})}
      >
        <svg width={isMobile ? "18" : "24"} height={isMobile ? "18" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V11" stroke="#0275D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17.5 3.5V8.5L19.5 6.5L21.5 8.5V3.5H17.5Z" stroke="#0275D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 14L12 14" stroke="#0275D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 10H16" stroke="#0275D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 18L10 18" stroke="#0275D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 9.5V18.5" stroke="#0275D8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="1 3"/>
        </svg>
      </Link>

      {/* Gallery - Black icon (elegant photo gallery) */}
      <Link 
        to="/gallery" 
        title="Gallery" 
        className="floating-btn"
        style={buttonBaseStyle}
        onMouseOver={e => Object.assign(e.currentTarget.style, getButtonHoverStyles())}
        onMouseOut={e => Object.assign(e.currentTarget.style, {transform: 'scale(1)', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'})}
      >
        <svg width={isMobile ? "18" : "24"} height={isMobile ? "18" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="18" height="18" rx="2" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="8.5" cy="8.5" r="1.5" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 15L16 10L9 17" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 17L9 14" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Link>

      {/* Challenges & Next Steps - Dark Purple icon (upward path/journey) */}
      <Link 
        to="/challenges" 
        title="Challenges & Next Steps" 
        className="floating-btn"
        style={buttonBaseStyle}
        onMouseOver={e => Object.assign(e.currentTarget.style, getButtonHoverStyles())}
        onMouseOut={e => Object.assign(e.currentTarget.style, {transform: 'scale(1)', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'})}
      >
        <svg width={isMobile ? "18" : "24"} height={isMobile ? "18" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#4B0082" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 12L12 8M12 8L8 12M12 8V16" stroke="#4B0082" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Link>
    </div>
  );
};

export default FloatingMenu;